export var State;
(function (State) {
    State["DRAFT"] = "DRAFT";
    State["PUBLISHED"] = "PUBLISHED";
    State["FINISHED"] = "FINISHED";
    State["ARCHIVED"] = "ARCHIVED";
})(State || (State = {}));
export var DurationUnit;
(function (DurationUnit) {
    DurationUnit["WEEKS"] = "WEEKS";
    DurationUnit["DAYS"] = "DAYS";
    DurationUnit["HOURS"] = "HOURS";
    DurationUnit["MINUTES"] = "MINUTES";
})(DurationUnit || (DurationUnit = {}));
export var AccessType;
(function (AccessType) {
    AccessType["PUBLIC"] = "PUBLIC";
    AccessType["PRIVATE"] = "PRIVATE";
    AccessType["SECRET"] = "SECRET";
})(AccessType || (AccessType = {}));
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["ONLINE_PAYMENT"] = "ONLINE_PAYMENT";
    PaymentMethod["OFFLINE_PAYMENT"] = "OFFLINE_PAYMENT";
})(PaymentMethod || (PaymentMethod = {}));
export var Trigger;
(function (Trigger) {
    /** a member joined the challenge */
    Trigger["JOINED_TO_CHALLENGE"] = "JOINED_TO_CHALLENGE";
    /** at least one step completed */
    Trigger["STEP_COMPLETED"] = "STEP_COMPLETED";
    /** all steps are completed. */
    Trigger["ALL_STEPS_COMPLETED"] = "ALL_STEPS_COMPLETED";
})(Trigger || (Trigger = {}));
export var MemberRole;
(function (MemberRole) {
    MemberRole["OWNER"] = "OWNER";
    MemberRole["PARTICIPANT"] = "PARTICIPANT";
    MemberRole["VIEWER"] = "VIEWER";
})(MemberRole || (MemberRole = {}));
export var SortingCriterion;
(function (SortingCriterion) {
    SortingCriterion["DEFAULT"] = "DEFAULT";
    SortingCriterion["ACTIVE_FIRST"] = "ACTIVE_FIRST";
    SortingCriterion["LAST_TRANSITION"] = "LAST_TRANSITION";
    SortingCriterion["CREATION_TIME"] = "CREATION_TIME";
})(SortingCriterion || (SortingCriterion = {}));
export var ParticipantState;
(function (ParticipantState) {
    ParticipantState["JOIN_REQUESTED"] = "JOIN_REQUESTED";
    ParticipantState["INVITED"] = "INVITED";
    ParticipantState["JOIN_REJECTED"] = "JOIN_REJECTED";
    ParticipantState["PAYMENT_REQUESTED"] = "PAYMENT_REQUESTED";
    ParticipantState["PAYMENT_STARTED"] = "PAYMENT_STARTED";
    ParticipantState["JOINED"] = "JOINED";
    ParticipantState["LEFT"] = "LEFT";
    ParticipantState["REMOVED"] = "REMOVED";
    ParticipantState["RUNNING"] = "RUNNING";
    ParticipantState["COMPLETED"] = "COMPLETED";
    ParticipantState["FAILED"] = "FAILED";
    ParticipantState["PAYMENT_STARTED_OFFLINE"] = "PAYMENT_STARTED_OFFLINE";
    ParticipantState["SUSPENDED"] = "SUSPENDED";
})(ParticipantState || (ParticipantState = {}));
export var ValidationStrategy;
(function (ValidationStrategy) {
    ValidationStrategy["FAIL_ON_ERRORS"] = "FAIL_ON_ERRORS";
    ValidationStrategy["FIX_ERRORS"] = "FIX_ERRORS";
})(ValidationStrategy || (ValidationStrategy = {}));
export var ChoiceRightness;
(function (ChoiceRightness) {
    ChoiceRightness["NEUTRAL"] = "NEUTRAL";
    ChoiceRightness["RIGHT"] = "RIGHT";
    ChoiceRightness["WRONG"] = "WRONG";
})(ChoiceRightness || (ChoiceRightness = {}));
//# sourceMappingURL=types.impl.js.map